export { ProductTitleAndLogo } from './ProductTitleAndLogo'
